import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="payment-forms"
export default class extends Controller {

  maybePreventSubmit(event) {
    // easier to determine the form from the event target than trying to configure the stimulus targets
    const form = event.target;

    if (form.dataset.submitted === 'true') {
      // Previously submitted - don't submit again
      event.preventDefault();
    } else if (!this._isFormValid(form)) {
      // Form is invalid, prevent submission
      event.preventDefault();
    } else {
      // Form is valid and not yet submitted
      form.dataset.submitted = 'true';

      // Disable the button after the event loop completes to avoid blocking submission
      const submitButton = form.querySelector('button[type=submit]');
      if (submitButton) {
        setTimeout(() => {
          submitButton.setAttribute('disabled', 'disabled');
        }, 0);
      }
    }
  }

  _isFormValid(form) {
    // Card forms delegate to the credit-card controller, which mirrors the old
    // jquery.validate rules (required / Luhn / expiry) with inline error UX.
    const cardController = this._creditCardControllerFor(form);
    if (cardController) {
      return cardController.validate();
    }

    // Non-card forms (transfer, cohortpay, external methods) carry no card
    // constraints, so native validation is a trivial pass-through.
    return form.checkValidity();
  }

  _creditCardControllerFor(form) {
    const element = form.closest('[data-controller~="credit-card"]');
    if (!element) return null;

    return this.application.getControllerForElementAndIdentifier(element, 'credit-card');
  }
}
